<template>
  <SpentTime :seconds="seconds" :class="{ 'opacity-45': seconds < 1 && !isActive }" />
</template>

<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import SpentTime from '@/components/elements/SpentTime.vue';

dayjs.extend(utc);

const props = defineProps({
  ttbu: Object,
  isActive: Boolean,
});

const store = useStore();

// tracked seconds of a user on a task, ticking while the user tracks it
const seconds = computed(() => {
  const { totalSeconds, timeSlots } = props.ttbu;
  const baseSeconds = (totalSeconds ?? 0)
    + (timeSlots ?? []).reduce((acc, slot) => acc + slot.actualTimeSeconds, 0);
  if (!props.isActive || !timeSlots?.length) {
    return baseSeconds;
  }
  const { nowUTC } = store.state.system;
  const now = nowUTC ? dayjs.utc(nowUTC) : dayjs().utc();
  return baseSeconds + (now - dayjs.utc(timeSlots[0].trackStarted)) / 1000;
});
</script>
